import '@/user/common';
import '@/shared/privacy_check';
import $ from 'jquery';
import { sliderSetting } from '@/shared/calendar';
import './progress';

$(() => {
    // フェア予約の場合、時間の選択肢をセット
    initFairTimes();

    // カレンダー初期表示
    sliderSetting(false, false);

    //ご婚礼予定月の選択可能不可能の表示分け
    if(document.querySelector('#marriage_month')){
        toggleMarriageMonthDisabled();
    }

    // 特典一覧のアコーディオンの開閉に速度をつける
    privilegeAccordionAnimation();

    // 日付選択にフォーカスした
    let $dateTarget = null; // 選択中の input
    $('.form-date__input').on('focus', e => {
        $dateTarget = $(e.currentTarget);
        $('.calendar, .calendar__bg').show();
        $('.js-slick__list.slick-initialized').slick('setPosition'); // 非表示要素にslick再適応
    });

    // 希望日を選択した
    $('.calendar').on('click', ".calendar__day-item:not('.is-disabled')", e => {
        let date = $(e.currentTarget)
            .find('input')
            .val();
        if (date && date.length) {
            // フォームに日付の入力
            $dateTarget.val(date).change(); // 進捗表示用に日付セットした際にchangeイベント発火させる
            // フェア予約の場合、選択可能時刻を更新する
            const timeTarget = $dateTarget
                .prop('id')
                .replace('preferred_date', '#reserve_time');
            setFairTimes($(timeTarget), date);
            $(".calendar__day-item input[type='checkbox']").prop('checked', false); // 日付のチェック解除
            $('.calendar, .calendar__bg').hide(); // カレンダー閉じる
        }
    });

    // 第一希望日のバツボタンをクリックした際、第一希望日の日付と時刻をリセット
    $('.js-date_cancel1').on('click', e => {
        document.getElementById('preferred_date1').value = "";
        if (document.getElementById('reserve_time1')){
            document.getElementById('reserve_time1').value = "";
        }else if (document.getElementById('reserve_hour1') && document.getElementById('reserve_minute1')){
            document.getElementById('reserve_hour1').value = "";
            document.getElementById('reserve_minute1').value = "";
        }
    });

    // 第二希望日のバツボタンをクリックした際、第二希望日の日付と時刻をリセット
    $('.js-date_cancel2').on('click', e => {
        document.getElementById('preferred_date2').value = "";
        if (document.getElementById('reserve_time2')){
            document.getElementById('reserve_time2').value = "";
        }else if (document.getElementById('reserve_hour2') && document.getElementById('reserve_minute2')){
            document.getElementById('reserve_hour2').value = "";
            document.getElementById('reserve_minute2').value = "";
        }
    });

    // 時刻（時）を変更したとき 00分にセット[通常予約・資料請求のみ]
    $("[id^='reserve_hour']").on('change', e => {
        const $target = $(e.currentTarget);
        const timeTarget = $target
            .prop('id')
            .replace('reserve_hour', '#reserve_minute'); // 対応する[分]
        $(timeTarget)
            .val('00')
            .change(); // 進捗表示用に日付セットした際にchangeイベント発火させる
    });

    // カレンダーモーダル背景押下でカレンダー閉じる
    $('.calendar__bg, .calendar__close').on('click', () => {
        $('.calendar, .calendar__bg').hide();
        return false;
    });

    // ご婚礼予定月の年選択で未定が選択された場合月を選択不可にする
    $("[id^='marriage_year']").on('change', () => {
        toggleMarriageMonthDisabled();
    });

    // EnterでSubmitされるのを防ぐ
    $('form:not([data-enableSubmit])').on('keydown.disableSubmit', e => {
        // テキストエリアは改行したいので除外します
        if ($(document.activeElement).prop('tagName') == 'TEXTAREA') {
            return true;
        }

        if (e.key === 'Enter') {
            e.preventDefault();
            return false;
        }
    });
});

/**
 * フェア開催時刻の選択肢を生成
 *
 * @param $target フェア開催時刻
 * @param date 選択したフェア日
 */
const setFairTimes = ($target, date) => {
    // 予約可能な時間
    const fairTimes = $('#cv_form').data('fair-times');
    if (fairTimes === undefined) {
        return;
    }
    const times = fairTimes[date] || [];

    // 選択肢の作成
    $target.empty();
    let optionTags = '<option value="">時間を選択</option>';
    for (let time of times) {
        optionTags += `<option value="${time}">${time}～</option>`;
    }

    $target.append(optionTags);
};

/**
 * フェアの開催日の開催時間の選択肢をセット
 */
const initFairTimes = () => {
    const $preferredDate1 = $('#preferred_date1');
    const $preferredDate2 = $('#preferred_date2');
    const $reserveTime1 = $('#reserve_time1');
    const $reserveTime2 = $('#reserve_time2');

    if ($preferredDate1.val()) {
        setFairTimes($reserveTime1, $preferredDate1.val());
        // バリデートエラー時に直近の選択を表示
        $reserveTime1.val($reserveTime1.data('old')).change(); // 進捗表示用にエラー後に時間をセットし直した際にchangeイベント発火させる
    }
    if ($preferredDate2.val()) {
        setFairTimes($reserveTime2, $preferredDate2.val());
        $reserveTime2.val($reserveTime2.data('old')).change(); // 進捗表示用にエラー後に時間をセットし直した際にchangeイベント発火させる
    }
};

/**
 *　ご婚礼予定月の選択可能不可能の表示分け
 */
const toggleMarriageMonthDisabled = () => {
    const formMarriageMonth = document.querySelector('#marriage_month');
    const formMarriageYear = document.querySelector('#marriage_year');

    // 年で未定を選択した場合
    if (isNaN(formMarriageYear.value)) {
        formMarriageMonth.disabled = true;
        // 月の選択肢を未入力の状態に戻す
        formMarriageMonth.value = '';
    } else {
        formMarriageMonth.disabled = false;
    }
};

/**
 * 特典一覧のアコーディオンの開閉に速度をつける
 */
const privilegeAccordionAnimation = () => {
    const $privilegeDetails = $('.js-reserve-privilege');
    const $privilegeSummary = $('.js-reserve-privilege__summary');
    const $privilegeList = $('.js-reserve-privilege__list');

    $(document).ready(() => {
        $privilegeList.slideUp(0);
    });

    $privilegeSummary.on('click', e => {
        e.preventDefault();
        if ($privilegeDetails.attr('open') === undefined) {
            $privilegeDetails.attr('open', true);
            $privilegeList.hide().slideDown(500);
        } else {
            $privilegeList.slideUp(500, () => {
                $privilegeDetails.removeAttr('open');
            });
        }
    })
};
